export class CorsBlockedError extends Error {
  constructor(public url: string) {
    super(`CORS blocked for ${url}`);
    this.name = 'CorsBlockedError';
  }
}

export class NetworkError extends Error {
  constructor(message: string, public status?: number) {
    super(message);
    this.name = 'NetworkError';
  }
}
export class InvalidURLError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'InvalidURLError';
  }
}
